"use strict";

import { AppDispatcher } from 'Dispatcher';
import { FormReportConstants } from "Constants/Forms/FormReportConstants";
export function formReportInitialize(formObj, _ref) {
  var form = _ref.form,
      popup = _ref.popup;
  AppDispatcher.dispatch({
    actionType: FormReportConstants.FORM_REPORT_INITIALIZE,
    formObj: formObj,
    formInst: form,
    popupInst: popup
  });
}
export function formReportNavigateToParent(UUID) {
  AppDispatcher.dispatch({
    actionType: FormReportConstants.FORM_REPORT_NAVIGATE_TO_PARENT,
    UUID: UUID
  });
}
export function formReportApply(UUID) {
  AppDispatcher.dispatch({
    actionType: FormReportConstants.FORM_REPORT_APPLY,
    UUID: UUID
  });
}
export function formReportUpdate(_ref2) {
  var nextData = _ref2.nextData,
      UUID = _ref2.UUID;
  AppDispatcher.dispatch({
    actionType: FormReportConstants.FORM_REPORT_UPDATE,
    nextData: nextData,
    UUID: UUID
  });
}